import React from 'react';

const Testimonials = () => {
  return (
    <section id="testimonials" style={{ padding: '2rem 0', backgroundColor: '#f5ebe0' }}>
      <h2 style={{ textAlign: 'center', color: '#b55b50', marginBottom: '2rem' }}>
        What Our Patients Say
      </h2>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <iframe
          src="https://bda463544ce842c2a259a5726c02faca.elf.site"
          width="100%"
          height="400px"
          style={{ border: 'none', maxWidth: '1100px' }}
          allow="fullscreen"
          title="Google Reviews"
        ></iframe>
      </div>
    </section>
  );
};

export default Testimonials;
